import { useEffect, useState } from 'react';
import { useStableApi } from '@/lib/api';

/**
 * One cell of the token detail grid: the workflow a workflow-bound token is scoped to,
 * named best-effort (a viewer without workflows.view.org sees the numeric binding).
 * Extracted from pages/ApiTokenDetail.jsx, which was already at its complexity ceiling.
 */
export default function WorkflowBinding({ workflowId }) {
  const { fetchApi } = useStableApi();
  const [name, setName] = useState(workflowId == null ? null : `#${workflowId}`);

  useEffect(() => {
    if (workflowId == null) return undefined;
    let alive = true;
    fetchApi('crud', { model: 'AppWorkflow', action: 'show', where: { id: workflowId } })
      .then((wf) => { if (alive) setName(wf?.data?.name || wf?.name || `#${workflowId}`); })
      .catch(() => {});
    return () => { alive = false; };
  }, [workflowId]);

  if (workflowId == null) return <p className="text-sm">— (company-wide)</p>;
  return (
    <>
      <p className="text-sm">{name}</p>
      <p className="text-xs text-secondary-500">Scoped to that workflow&apos;s endpoints only</p>
    </>
  );
}
